import { render, staticRenderFns } from "./GlobalHeaderNav.vue?vue&type=template&id=b90a7144&scoped=true"
import script from "./GlobalHeaderNav.vue?vue&type=script&lang=js"
export * from "./GlobalHeaderNav.vue?vue&type=script&lang=js"
import style0 from "./GlobalHeaderNav.vue?vue&type=style&index=0&id=b90a7144&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90a7144",
  null
  
)

export default component.exports